import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";

import { getGroupActions } from "@/App/actions";
import { PageAlert } from "@/App/components";
import { ActionTypes } from "@/App/constants/actionTypes";
import apiService from "@/App/service";

export function* getGroup(payload: {}): Generator {
  return yield apiService({
    url: "/group/get",
    method: "POST",
    data: { id: payload },
  });
}

export function* getGroupWorker(action: ReturnType<typeof getGroupActions.getGroup>): SagaIterator {
  const { payload } = action;
  const { getGroupResults } = getGroupActions;
  const { showPageAlert } = PageAlert;

  try {
    const group = yield call(getGroup, payload);
    yield put(getGroupResults(group));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* getGroupWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_GROUP, getGroupWorker);
}
